export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/ContactUsIcon.808b6f7f.svg","height":73,"width":87,"blurWidth":0,"blurHeight":0};